var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconsOtherBoxHome = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.49582 14.9958V14.9958C2.49582 16.3765 3.61511 17.4958 4.99582 17.4958H14.9958C16.3765 17.4958 17.4958 16.3765 17.4958 14.9958V14.9958V8.88415C17.4953 8.1133 17.1393 7.38578 16.5308 6.91248L11.5308 3.02332C10.628 2.321 9.36365 2.321 8.46082 3.02332L3.46082 6.91248C2.85238 7.38578 2.49631 8.1133 2.49582 8.88415V14.9958Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconsOtherBoxHome);
export default ForwardRef;